import React from "react";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import { NumericFormat } from "react-number-format";

const CFATextfield = ({ onChange, label, value, error,name="" ,disabled=false}) => {
  const materialUITextFieldProps = {
    id: "filled-multiline-flexible",
    label: label,
    variant: "outlined"
  };
  return (
    <NumericFormat
    value={value}
    name={name}
    onChange={onChange}
    customInput={TextField}
    valueIsNumericString={false}
    disabled={disabled}
    error={error}
    {...materialUITextFieldProps}
    // suffix=" CFA"
  />
    // <TextField
    //   type="text"
    //   value={value}
    //   name={label}
    //   id="input-with-icon-textfield"
    //   label={label}
    //   onChange={onChange}
    //   error={error}
    //   InputProps={{
    //     inputComponent: NumberFormatCustom,
    //   }}
    //   // InputProps={{
    //   //   endAdornment: (
    //   //     <InputAdornment
    //   //       position="end"
    //   //       style={{
    //   //         background: "red",
    //   //         color: "#979797",
    //   //         backgroundColor: "#EDEDED",
    //   //         padding: "32px 12px",
    //   //       }}
    //   //     >
    //   //       <div>CFA</div>
    //   //     </InputAdornment>
    //   //   ),
    //   // }}
    //   variant="outlined"
    // />
  );
};

export default CFATextfield;
